/** A copy of a `<template id>`'s content, for an element's markup. The markup lives in the
    HTML, so no script builds markup from strings, which the CSP's Trusted Types rule forbids. */
export function templateContent(id: string): DocumentFragment {
  const template = document.getElementById(id);
  if (!(template instanceof HTMLTemplateElement)) throw new Error(`template #${id} is missing`);
  return document.importNode(template.content, true);
}
